import axios from 'axios';
import { LOGIN_ADMIN, LOGOUT_ADMIN, PROFILE_ADMIN, UPDATE_ADMIN_PROFILE } from './admin.type';
import { toast } from 'react-toastify';
import config from '../../config/config';

// Configure axios base URL
const api = axios.create({
  baseURL: config.API.BASE_URL,
  timeout: config.API.TIMEOUT,
});

export const loginAdmin = (loginData) => async (dispatch) => {
  try {
    const res = await api.post('/admin/login', loginData);
    if (res.data.status) {
      localStorage.setItem(config.SECURITY.TOKEN_KEY, res.data.token);
      dispatch({ type: LOGIN_ADMIN, payload: res.data.token });
      toast.success('Login Successfully!');
      // You might want to fetch the profile right after login
      dispatch(getProfile());
    } else {
      toast.error(res.data.message);
    }
  } catch (error) {
    console.error(error);
    toast.error(error.response?.data?.message || 'An error occurred');
  }
};

export const getProfile = () => async (dispatch) => {
  try {
    const token = localStorage.getItem(config.SECURITY.TOKEN_KEY);
    if (!token) return dispatch({ type: LOGOUT_ADMIN });

    // Set auth token header
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    // Make API call to get admin profile
    const res = await api.get('/admin/profile');
    if (res.data.status) {
      dispatch({ type: PROFILE_ADMIN, payload: res.data.admin });
    } else {
      // Fallback to token decoding if API call fails
      const decodedToken = JSON.parse(atob(token.split('.')[1]));
      dispatch({ type: PROFILE_ADMIN, payload: { email: decodedToken.email, name: 'Admin' } });
    }

  } catch (error) {
    console.error(error);
    // Try fallback method
    try {
      const token = localStorage.getItem(config.SECURITY.TOKEN_KEY);
      const decodedToken = JSON.parse(atob(token.split('.')[1]));
      dispatch({ type: PROFILE_ADMIN, payload: { email: decodedToken.email, name: 'Admin' } });
    } catch (fallbackError) {
      dispatch({ type: LOGOUT_ADMIN });
    }
  }
};

export const logoutAdmin = () => (dispatch) => {
  localStorage.removeItem(config.SECURITY.TOKEN_KEY);
  delete api.defaults.headers.common['Authorization'];
  dispatch({ type: LOGOUT_ADMIN });
  toast.info('Logged out successfully.');
};

export const changeAdminPassword = (passwordData) => async (dispatch) => {
  try {
    const token = localStorage.getItem(config.SECURITY.TOKEN_KEY);
    if (!token) return dispatch({ type: LOGOUT_ADMIN });

    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
    const res = await api.put('/admin/change-password', passwordData);
    if (res.data.status) {
      toast.success('Password changed successfully!');
      return { success: true };
    } else {
      toast.error(res.data.message);
      return { success: false, message: res.data.message };
    }
  } catch (error) {
    console.error(error);
    const errorMessage = error.response?.data?.message || 'Error changing password';
    toast.error(errorMessage);
    return { success: false, message: errorMessage };
  }
};

export const updateAdminProfile = (profileData) => async (dispatch) => {
  try {
    const token = localStorage.getItem(config.SECURITY.TOKEN_KEY);
    if (!token) return dispatch({ type: LOGOUT_ADMIN });

    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
    const res = await api.put('/admin/profile', profileData);
    if (res.data.status) {
      dispatch({ type: UPDATE_ADMIN_PROFILE, payload: res.data.admin });
      toast.success('Profile updated successfully!');
      return { success: true, admin: res.data.admin };
    } else {
      toast.error(res.data.message);
      return { success: false, message: res.data.message };
    }
  } catch (error) {
    console.error(error);
    const errorMessage = error.response?.data?.message || 'Error updating profile';
    toast.error(errorMessage);
    return { success: false, message: errorMessage };
  }
};